
    import './styles.scoped.css';
    export default {
  "arrow": "awsui_arrow_xjuzf_hx6ih_9",
  "arrow-outer": "awsui_arrow-outer_xjuzf_hx6ih_13",
  "arrow-inner": "awsui_arrow-inner_xjuzf_hx6ih_13",
  "arrow-position-right-top": "awsui_arrow-position-right-top_xjuzf_hx6ih_44",
  "arrow-position-right-bottom": "awsui_arrow-position-right-bottom_xjuzf_hx6ih_44",
  "arrow-position-left-top": "awsui_arrow-position-left-top_xjuzf_hx6ih_47",
  "arrow-position-left-bottom": "awsui_arrow-position-left-bottom_xjuzf_hx6ih_47",
  "arrow-position-top-center": "awsui_arrow-position-top-center_xjuzf_hx6ih_50",
  "arrow-position-top-right": "awsui_arrow-position-top-right_xjuzf_hx6ih_50",
  "arrow-position-top-left": "awsui_arrow-position-top-left_xjuzf_hx6ih_50",
  "arrow-position-top-responsive": "awsui_arrow-position-top-responsive_xjuzf_hx6ih_50",
  "arrow-position-bottom-center": "awsui_arrow-position-bottom-center_xjuzf_hx6ih_53",
  "arrow-position-bottom-right": "awsui_arrow-position-bottom-right_xjuzf_hx6ih_53",
  "arrow-position-bottom-left": "awsui_arrow-position-bottom-left_xjuzf_hx6ih_53",
  "arrow-position-bottom-responsive": "awsui_arrow-position-bottom-responsive_xjuzf_hx6ih_53",
  "body": "awsui_body_xjuzf_hx6ih_61",
  "body-overflow-visible": "awsui_body-overflow-visible_xjuzf_hx6ih_79",
  "variant-annotation": "awsui_variant-annotation_xjuzf_hx6ih_83",
  "body-size-small": "awsui_body-size-small_xjuzf_hx6ih_88",
  "fixed-width": "awsui_fixed-width_xjuzf_hx6ih_91",
  "body-size-medium": "awsui_body-size-medium_xjuzf_hx6ih_95",
  "body-size-large": "awsui_body-size-large_xjuzf_hx6ih_102",
  "has-dismiss": "awsui_has-dismiss_xjuzf_hx6ih_109",
  "dismiss": "awsui_dismiss_xjuzf_hx6ih_114",
  "dismiss-control": "awsui_dismiss-control_xjuzf_hx6ih_121",
  "header-row": "awsui_header-row_xjuzf_hx6ih_125",
  "header": "awsui_header_xjuzf_hx6ih_125",
  "content": "awsui_content_xjuzf_hx6ih_147",
  "content-overflow-visible": "awsui_content-overflow-visible_xjuzf_hx6ih_154",
  "container": "awsui_container_xjuzf_hx6ih_158",
  "container-arrow": "awsui_container-arrow_xjuzf_hx6ih_166",
  "container-arrow-position-right-top": "awsui_container-arrow-position-right-top_xjuzf_hx6ih_170",
  "container-arrow-position-right-bottom": "awsui_container-arrow-position-right-bottom_xjuzf_hx6ih_170",
  "container-arrow-position-left-top": "awsui_container-arrow-position-left-top_xjuzf_hx6ih_182",
  "container-arrow-position-left-bottom": "awsui_container-arrow-position-left-bottom_xjuzf_hx6ih_182",
  "container-arrow-position-top-center": "awsui_container-arrow-position-top-center_xjuzf_hx6ih_194",
  "container-arrow-position-top-right": "awsui_container-arrow-position-top-right_xjuzf_hx6ih_194",
  "container-arrow-position-top-left": "awsui_container-arrow-position-top-left_xjuzf_hx6ih_194",
  "container-arrow-position-top-responsive": "awsui_container-arrow-position-top-responsive_xjuzf_hx6ih_194",
  "container-arrow-position-bottom-center": "awsui_container-arrow-position-bottom-center_xjuzf_hx6ih_210",
  "container-arrow-position-bottom-right": "awsui_container-arrow-position-bottom-right_xjuzf_hx6ih_214",
  "container-arrow-position-bottom-left": "awsui_container-arrow-position-bottom-left_xjuzf_hx6ih_218",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_xjuzf_hx6ih_1",
  "refresh": "awsui_refresh_xjuzf_hx6ih_248",
  "root": "awsui_root_xjuzf_hx6ih_270",
  "trigger": "awsui_trigger_xjuzf_hx6ih_281",
  "trigger-type-text": "awsui_trigger-type-text_xjuzf_hx6ih_286",
  "trigger-inner-text": "awsui_trigger-inner-text_xjuzf_hx6ih_315"
};
  